import { render } from "./IRRChart.vue?vue&type=template&id=1d0f1d3c"
import script from "./IRRChart.vue?vue&type=script&lang=js"
export * from "./IRRChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__